import axios from 'axios';

export const fetchNigeriaBanks = async () => {
  const response = await axios.get('https://nigerianbanks.xyz');
  return response.data;
};
